import AdsError from './AdsError.js'

export class GetAdDetailsPartialContentError extends AdsError {
  constructor({adId, message, status, origin}) {
    super()

    this.adId = adId
    this.message = message
    this.status = status
    this.origin = origin
  }
}
